import { Button } from "@/components/ui/button";
import { FileText, ArrowRight } from "lucide-react";

export default function AppLinkBanner({ link, dueDate, testId }) {
  return (
    <section className="bg-white border-b border-slate-100" data-testid={testId}>
      <div className="container-main py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 bg-slate-50 rounded-xl border border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#0F172A] flex items-center justify-center shrink-0">
              <FileText className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-sm text-[#0F172A]" style={{ fontFamily: 'Manrope, sans-serif' }}>Committee Application</h3>
              <p className="text-slate-500 text-xs mt-0.5">Due: {dueDate || "TBA"}</p>
            </div>
          </div>
          {link ? (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#0F172A] hover:bg-[#1E293B] text-white rounded-full px-5 text-xs font-semibold whitespace-nowrap">
                Apply Now <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
              </Button>
            </a>
          ) : (
            <Button className="bg-slate-200 text-slate-400 rounded-full px-5 text-xs font-semibold cursor-not-allowed" disabled>
              Coming Soon
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
